<template>
  <main class="wrapper-content pr-0">
    <!-- Loading -->
    <LmComponentLoading v-if="isLoading" fixed />
    <b-row>
      <b-col>
        <portal to="peopleSubTitle">
          <LmHtmlContent
            class="col-12 px-0"
            :html="`<h5>Tipo de persona: ${peopleTypeName}</h5>`"
          />
        </portal>
        <portal to="peopleName">
          <!-- Input del nombre -->
          <LmTextInput
            :disabled="deleted"
            class="col-12 px-0"
            v-model="form.personName"
            :v="$v.form.personName"
            :label="$t('people_name')"
            :placeholder="$t('people_name_placeholder')"
          />
        </portal>
        <portal to="personIdType">
          <!-- Input del Tipo de ID -->
          <LmTreeSelect
            :disabled="deleted"
            :v="$v.form.personIdType"
            :label="$t('people_idtype')"
            :options="idType"
            v-model="form.personIdType"
          />
        </portal>
        <portal to="personId">
          <!-- Input del ID -->
          <LmTextInput
            :disabled="deleted"
            @enter="onSubmit"
            class="col-12 px-0"
            v-model="form.personId"
            :v="$v.form.personId"
            :label="$t('people_id_number')"
            :placeholder="$t('people_id_number_placeholder')"
          />
        </portal>
        <portal to="personEmail">
          <!-- Input del email -->
          <LmEmailInput
            :disabled="deleted"
            @enter="onSubmit"
            :v="$v.form.personEmail"
            v-model="form.personEmail"
            :label="$t('email')"
            placeholder="Ingrese el email"
          />
        </portal>
        <!-- Formbuilder Server Components -->
        <LmFormBuilder
          :isDisabled="deleted"
          class="px-0"
          v-if="formbuilderId"
          ref="lmFormbuilder"
          :endpointUriwhereGetComponents="formbuilderPath"
          :endpointUriWhereGetValuesToLoadInEditMode="dataPathOnEditMode"
          @formObjectToSendToServerChange="updateForm($event)"
        />
      </b-col>
      <!-- Toolbar -->
      <LmToolbar
        ref="toolbar"
        :isOnEditMode="isOnEditMode"
        :items="toolbarItems"
        :config="toolbarConfig"
      />
    </b-row>

    <!-- Action Buttons -->
    <b-row class="mt-5">
      <LmButton
        :value="$t('cancel')"
        class="col-auto"
        type="button"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        v-if="!deleted"
        :value="$t('save')"
        class="col-auto"
        type="button"
        buttonClass="btn-primary"
        @click="onSubmit()"
      />
      <LmButton
        v-if="isOnEditMode && !deleted"
        :value="$t('delete')"
        class="col-auto"
        type="button"
        action="delete"
        buttonClass="btn-danger"
        @click="onDelete()"
      />
    </b-row>
  </main>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmHtmlContent from '@/components/form/elements/LmHtmlContent'
import LmFormBuilder from '@/components/LmFormBuilder'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

import LmToolbar from '@/components/lmToolBar'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import { EventBus } from '@/event-bus.js'

import {
  required, email
} from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  components: {
    LmFormBuilder,
    LmButton,
    LmTreeSelect,
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmHtmlContent,
    LmToolbar
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModalEditMode: {
      type: Boolean,
      default: false
    },
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    },
    peopleTypeId: {
      type: String,
      default: null
    },
    personData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      screenWidth: screen.width,
      toolbarMode: null,
      formbuilderId: '',
      listbuilderId: '',
      peopleTypeName: '',
      published: false,
      deleted: false,
      idType: [],
      form: {
        personName: '',
        personEmail: '',
        personId: ''
      },
      isLoading: false
    }
  },
  validations: {
    form: {
      personName: {
        required
      },
      personIdType: {
        required
      },
      personId: {
        required
      },
      personEmail: {
        required,
        email
      }
    }
  },
  computed: {
    formbuilderPath () {
      return `/formbuilder/${this.formbuilderId}`
    },
    dataPathOnEditMode () {
      let targetEndpoint = ''
      if (this.isOnEditMode) {
        targetEndpoint = `/people/${this.$route?.params?.id}`
      }
      if (this.isOnModalEditMode) {
        targetEndpoint = `/people/${this.personData?._id}`
      }
      return targetEndpoint
    },
    personId () {
      if (this.personData) {
        return this.personData._id
      }
      return this.$route.params.id
    },
    calledAsComponent () {
      return !!this.peopleTypeId
    },
    toolbarItems () {
      let items = []
      if (this.isOnEditMode) {
        items = [
          'auditMovements'
        ]
      }
      return items
    },
    toolbarConfig () {
      return {
        auditMovements: {
          serviceName: 'people'
        }
      }
    }
  },
  methods: {
    async onSubmit () {
      try {
        this.isLoading = true

        // Validaciones
        await this.validateForm(this.$v)
        await this.validateForm(this.$refs.lmFormbuilder.$v)

        const dataToSendToServer = {
          ...this.form
        }
        if (this.peopleTypeId) {
          dataToSendToServer.peopleTypeId = this.peopleTypeId
        }
        let res
        if (!this.isOnEditMode && !this.isOnModalEditMode) {
          // nuevo
          res = await commonsApi.axiosPostWrapper('/people/', dataToSendToServer)
          this.lmToastSuccessMessage(`Se creó ${res?.data?.personName || 'la persona'} correctamente.`, 'Se guardó exitosamente')
          this.$emit('onNewPerson', res.data)
        } else {
          // editar
          res = await commonsApi.axiosPutWrapper(`/people/update/${this.personId}`, dataToSendToServer)
          this.lmToastSuccessMessage(`Se editó ${res?.data?.personName || 'la persona'} correctamente.`, 'Se guardó exitosamente')
          this.$emit('onUpdatePerson', res.data)
        }
        // Esta prop la define un llamado desde el modal por lo que es innecesaria
        if (!this.calledAsComponent) {
          setTimeout(() => {
            this.$router.push(this.pathToRedirectOnCancel)
          }, 650)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        await commonsApi.axiosPutWrapper(`/people/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(`Se eliminó ${this.form?.personName || 'la persona'} correctamente.`, 'Persona eliminada.')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      if (this.calledAsComponent) {
        this.$emit('cancel')
      } else {
        this.$router.push(this.pathToRedirectOnCancel)
      }
    },
    updateForm (event) {
      this.form = Object.assign({}, this.form, event)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async loadContentOnEditMode () {
      if (this.isOnEditMode) {
        try {
          this.isLoading = true
          const person = await commonsApi.axiosGetWrapper(`/people/${this.$route.params.id}`)
          this.form.personName = person.data.personName
          this.form.personEmail = person.data.personEmail
          this.form.personIdType = person.data.personIdType
          this.form.personId = person.data.personId
          this.deleted = person.data.deleted
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      }
    },
    loadContentFromProp () {
      this.form.personName = this.personData.personName
      this.form.personEmail = this.personData.personEmail
      this.form.personIdType = this.personData.personIdType
      this.form.personId = this.personData.personId
    }
  },
  async created () {
    try {
      const targetEndpoint = this.peopleTypeId || this.$route.params.peopleTypeId

      const peopleType = await commonsApi.axiosGetWrapper(`/peopletypes/${targetEndpoint}`)

      this.formbuilderId = peopleType.data.formbuilderId
      this.listbuilderId = peopleType.data.listbuilderId
      this.form.peopleTypeId = peopleType.data._id
      this.peopleTypeName = peopleType.data.typeName
      this.published = peopleType.data.published
      this.idType = peopleType.data.idType

      if (!this.isOnEditMode && !this.published) {
        EventBus.$emit('lmShowGlobalToast', {
          toastMessage: 'Debes publicar el Tipo de Persona para poder añadirle Personas.',
          toastAttributes: {
            title: 'Error',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: true
          }
        })
        this.$router.push(this.pathToRedirectOnCancel)
      }
      // Asigno la consulta enviada en PeopleSearcher para crear la nueva persona
      if (this.personData) {
        this.loadContentFromProp()
      } else {
        await this.loadContentOnEditMode()
      }
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
